import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"


import BiTmplDetail_20 from '@/views/bi-tmpl/src/components/bi-tmpl-detail/bi-tmpl-detail-20.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-22',
  props: ['disabled'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BiTmplDetail_20, { disabled: __props.disabled }, null, 8, ["disabled"]))
}
}

})